import { useState, useEffect } from 'react';

/**
 * Returns a debounced value that updates after the specified delay.
 * Useful for search inputs to prevent excessive filtering.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
